import axios from 'axios';

export function useData<T extends Object>(url: string, method: ("GET" | "POST"), accept?: ("text/plain" | "application/json")) : readonly[(onSuccess: (data?: T) => void, onError: (error: any) => void, body?:any, token?: string) => void] {
    const executeApiCall = (onSuccess: (data?: T) => void, onError: (error: any) => void, body?: any, token?: string) => {
        if(url && ((method === "POST" && !!body) || method === "GET")) {
            const promise = method === "GET" ? axios.get(`${window.location.origin}/api/${url}`, {  headers: {
                "Accept": accept??"text/plain",
                "Authorization": token ? `Bearer ${token}` : undefined
            }, withCredentials: true }) : axios.post(`${window.location.origin}/api/${url}`, body, {  
                headers: {
                "Accept": accept??"application/json",
                'Content-Type': 'application/json',
                "Authorization": token ? `Bearer ${token}` : undefined
                },
                withCredentials: true
            });

            promise.then(res => {
                //checking for multiple responses for more flexibility 
                //with the url we send in.
                console.log("Response", res.data);
                onSuccess(res?.data);
            })
            .catch(err => {
                onError(JSON.stringify(err))
            })
        }
    }

    return [executeApiCall] as const;
}